<template>
    <div>
        <div class="d-flex mb-3">
            <h4>Anexos - {{ investimento.descricao }}</h4>
        </div>
        <app-tabela
            idTabela="tblAnexos"
            :itens="investimento.documentos"
            :campos="campos"
            :itensPorPagina="itensPorPagina"
            :bordered="false"
            :small="false"
        >
            <template slot="botoes">
                <div class="d-flex flex-row-reverse mb-3">
                    <b-button class="ml-3" variant="danger" @click="$emit('voltarParaInvestimentos')">
                        <span>
                            <i class="fa fa-history mr-2"></i> Retornar para os Investimentos
                        </span>
                    </b-button>
                    <btn-inserir
                        :investimento="investimento"
                        @obterAnexosAtualizados="obterAnexos()"
                    ></btn-inserir>
                </div>
            </template>
            <template slot="acoes" slot-scope="data">
                <btn-download
                    :anexo="data"
                ></btn-download>
                <btn-excluir
                    :anexo="data"
                    @obterAnexosAtualizados="obterAnexos()"
                ></btn-excluir>
            </template>
        </app-tabela>
    </div>
</template>

<script>
import InvestimentoServicos from '../InvestimentoServicos'
import AnexoServicos from './AnexoServicos';
import BtnInserir from './BtnInserirAnexo'
import BtnExcluir from './BtnExcluirAnexo'
import BtnDownload from './BtnDownloadAnexo.vue';

export default {
    components: {
        BtnInserir,
        BtnDownload,
        BtnExcluir,
    },
    props: {
        investimento: {
            type: Object,
            default: () => {}
        },
    },
    data() {
        return {
            campos: [
                {
                    key: 'descricao',
                    label: 'Descrição',
                    sortable: true,
                    filterable: true
                },
                {
                    key: 'documento',
                    label: 'Anexo',
                    sortable: true,
                },
                {
                    key: 'acoes',
                    label: 'Ações'
                }
            ],
            itensPorPagina: 5
        }
    },
    methods: {
        obterInvestimentos() {
            this.$store.dispatch('addRequest')
            InvestimentoServicos.obterInvestimentos(
                this.$route.params.contratoId
            ).then(response => {
                if (response) {
                    if (response.success) {
                        this.$emit('atualizarInvestimentos', response.data)
                    } else {
                        this.$toast.error(
                            'Erro ao obter os investimentos',
                            'ERROR',
                            this.$toastConfig.error
                        )
                    }
                }
                this.$store.dispatch('removeRequest')
            })
        },

        obterAnexos() {
            let anexoDto = {
                idContrato: this.investimento.idContrato,
                idInvestimentoPrevistoContrato: this.investimento.idInvestimentoPrevistoContrato
            }
            this.$store.dispatch('addRequest')
            AnexoServicos.obterAnexos(anexoDto).then(response => {
                if (response) {
                    if (response.success) {
                        this.investimento.documentos = response.data
                    } else {
                        this.$toast.error(
                            'Erro ao obter os anexos',
                            'ERROR',
                            this.$toastConfig.error
                        )
                    }
                }
                this.$store.dispatch('removeRequest')
            })
        },
    },
    
    created() {},

    computed: {},

    watch: {}
}
</script>
